import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import SimpleImageSlider from "react-simple-image-slider";
const AgronomyRecommendationForm = (props) => {
  const frmRef = useRef({});

  const { sendRequest: getAgronomy } = useHttp();

  const { sendRequest: getObservation } = useHttp();

  const [agronomyData, setAgronomyData] = useState("");
  const [fieldActivityDetailId, setFieldActivityDetailId] = useState(0);
  const [cropPlotId, setcropPlotId] = useState(0);
  const [observationData, setObservationData] = useState(0);

  const [images, setImages] = useState();

  const [sliderImages, setSliderImages] = useState([""]);
  const handleDelete = (index, e) => {
    setSliderImages([""]);

    // var item = agronomyData.filter((v, i) => i == index);

    var itemlist = observationData.filter(
      (item) =>
        item.fieldActivityDetailId ==
        observationData[index].fieldActivityDetailId
    );

    //console.log("item", itemlist);
    const files = itemlist[0] && itemlist[0].urlAttachments;
    // const url = JSON.parse(files);
    const url = files;
    setImages(url);

    if (url) {
      const baseFileUrl = process.env.REACT_APP_FILE_URL;
      const imagesWithBaseUrl = url.map((filePath) => baseFileUrl + filePath);

      if (imagesWithBaseUrl.length > 0) {
        setSliderImages(imagesWithBaseUrl);
      }
    } else {
      setSliderImages([""]);
    }

    if (itemlist.length > 0) {
      //console.log(itemlist[0].fieldActivityDetailId);

      setFieldActivityDetailId(itemlist[0].fieldActivityDetailId);

      // frmRef.current.Observation.value = itemlist[0].cropObservation;
    }
  };

  useEffect(() => {
    getObservation(
      {
        url: `/api/fieldActivityRecommendation/?fieldActivityId=10&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },

      (res) => {
        if (res) {
          //console.log("getObservation", res);

          var agronomyData = res.filter(
            (item) => (item.recommendation ?? "") == ""
          );

          setObservationData(agronomyData);
        }
      }
    );
  }, [getObservation]);

  const { sendRequest: updateRecommendation } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    const data = {
      fieldActivityDetailId: fieldActivityDetailId,
      recommendation: frmRef.current.recommendation.value,
    };

    //console.log(data);
    updateRecommendation(
      {
        url: "/api/fieldActivityRecommendation/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success("Update Recommendation");
      },
      (error) => {
        // //console.log(error);
        toast.error("error");
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <div className="container-fluid">
            {/* SELECT2 EXAMPLE */}
            <div className="card card-default">
              <div className="card-header">
                <h3 className="card-title">
                  Add Agronomy Recommendation Detail
                </h3>
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => props.addForm(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
              {/* /.card-header */}
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      {images &&
                        images.map((filePath, index) => (
                          <img
                            key={index}
                            alt={`Image ${index}`}
                            src={`${process.env.REACT_APP_FILE_URL}${filePath}`}
                            height="100"
                            width="100"
                          />
                        ))}
                    </div>
                  </div>
                </div>

                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-md-6">
                      <label>Observation</label>

                      <input
                        type="text"
                        id="recommendation"
                        readOnly
                        className="form-control"
                        ref={(el) => (frmRef.current["Observation"] = el)}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label>Recommendation </label>
                      <input
                        type="text"
                        id="recommendation"
                        className="form-control"
                        ref={(el) => (frmRef.current["recommendation"] = el)}
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-md-4">
                      <br />
                      <button className="btn btn-primary">Submit</button>
                    </div>
                  </div>
                </form>
                <br />
                <div className="row">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Doc No</th>
                        <th>Start Date</th>
                        <th>Start Time</th>

                        <th>Plot Name</th>
                        <th>Crop Name</th>
                        <th>Variety </th>
                        <th>Area </th>
                        <th>Farm Manager </th>

                        <th>Recommendation</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {observationData &&
                        observationData.map((itm, i) => (
                          <tr key={i}>
                            <td>{itm.FieldActivityNo}</td>
                            <td>{itm.startDate}</td>
                            <td>{itm.startTime}</td>

                            <td>{itm.plotName}</td>
                            <td>{itm.cropName}</td>
                            <td>{itm.varietyName}</td>

                            <td>
                              {itm.activityArea}
                              {itm.activityAreaUnit}
                            </td>
                            <td>{itm.farmManager}</td>

                            <td>{itm.recommendation}</td>
                            <td>
                              <button
                                
                                className="btn btn-sm btn-success"
                                onClick={(e) => handleDelete(i, e)}
                              >
                                Recommendation
                              </button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                <div className="row">
                  <div className="col-md-4"></div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-1">
                    {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                  </div>
                  <div className="col-md-1"> </div>
                  <div className="col-md-4"></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AgronomyRecommendationForm;
